module.exports = __webpack_public_path__ + "img/ethereum.accf7c19.png";